import Vue from "vue"
import moment from "moment"
import { Validator } from 'vee-validate'
import VueCookies from 'vue-cookies'

export default class {
    constructor() {
        this.lang = {
            default: 'en',
            storage: localStorage.getItem('lang'),
            browser: navigator.language.substr(0, 2),
        }

        this.set(this.get())
    }

    get() {
        if (this.lang.storage && Vue.i18n.locales().indexOf(this.lang.storage)) {
            return this.lang.storage
        }

        if (this.lang.browser)
            return this.lang.browser

        return this.lang.default
    }

    async set(lang) {
        const shadowLang = lang === 'ru' ? lang : 'en'

        localStorage.setItem('lang', shadowLang)
        await Vue.i18n.set(shadowLang)
        moment.locale(shadowLang)
        Validator.localize(shadowLang)

        if (typeof(Event) === 'function') {
            window.dispatchEvent(new Event('resize'));
        } else {
            let evt = window.document.createEvent('UIEvents');
            evt.initUIEvent('resize', true, false, window, 0);
            window.dispatchEvent(evt);
        }

        let langCode = 0;
        switch (lang) {
            case 'ru':
                langCode = 1
                break
            case 'fr':
                langCode = 2
                break
            case 'pt':
                langCode = 3
                break
        }

        VueCookies.set('language', langCode, 0, '/webview')
    }
}



// WEBPACK FOOTER //
// ./src/services/LocalizationService.js